import { Button } from '@/components/ui/button';
import { useState } from 'react';

export const PortfolioFilters = ({ onFilter }: { onFilter: (filters: string[]) => void }) => {
  const categories = ["All", "Web", "Mobile", "AI", "Blockchain", "SaaS", 'E-Commerce', 'Finance', 'Healthcare'];
  const [activeFilters, setActiveFilters] = useState<string[]>(["All"]);

  const handleFilter = (category: string) => {
    let newFilters = [...activeFilters];
    
    if (category === "All") {
      newFilters = ["All"];
    } else {
      if (newFilters.includes("All")) {
        newFilters = newFilters.filter(f => f !== "All");
      }
      
      if (newFilters.includes(category)) {
        newFilters = newFilters.filter(f => f !== category);
        if (newFilters.length === 0) newFilters = ["All"];
      } else {
        newFilters.push(category);
      }
    }
    
    setActiveFilters(newFilters);
    onFilter(newFilters.includes("All") ? [] : newFilters);
  };

  return (
    <div className="flex flex-wrap gap-2 mb-8 bg-white p-4 rounded-lg border-2 border-purple-500/20 shadow-lg">
      <p className="w-full text-sm font-medium text-purple-600 mb-2">FILTER BY CATEGORY:</p>
      {categories.map(category => (
        <Button
          key={category}
          className={`rounded-full px-4 py-2 font-medium transition-all ${activeFilters.includes(category) 
            ? "bg-gradient-to-r from-purple-800 to-pink-700 text-white shadow-lg" 
            : "bg-white text-purple-800 border-2 border-purple-800/30 hover:bg-purple-800/10 hover:border-purple-800/50"}`}
          onClick={() => handleFilter(category)}
        >
          {category}
        </Button>
      ))}
    </div>
  );
};
